import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@tecumseh/theme/design";
import { css } from "styled-components";

columnsStyles.container = {
    gap: 70,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    null,
                    css`
                        margin-bottom: 30px;
                    `,
                    null,
                ],
                "minMax",
            )};
        > div[class^="GridOffset"] {
            margin: 0;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        width: 100%;
                    `,
                    css`
                        width: 100%;
                    `,
                    null,
                    null,
                    null,
                ])};
        }
    `,
};

columnsStyles.leftColumnGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        opacity: 1;
        background-color: rgba(17, 41, 69, 0.027972);
        position: relative;
        padding: 30px 10px;
        &::after {
            content: "";
            position: absolute;
            width: 49px;
            bottom: -24px;
            right: -24px;
            height: 49px;
            border: 2px solid transparent;
            background-color: ${COLORS.background.base};
            border-image-slice: 10%;
            transform: rotateZ(45deg);
        }
        &:before {
            content: "";
            position: absolute;
            height: 100%;
            top: 0px;
            background-color: rgba(17, 41, 69, 0.027972);
        }
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    display: none;
                `,
                css`
                    padding-left: 15px;
                    padding-right: 15px;
                `,
                null,
            ])}
    `,
};

columnsStyles.rightColumnGridItem = {
    width: [12, 12, 12, 9, 9],
    css: css`
        padding: 10px;
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css``,
                css``,
                css`
                    margin: auto !important;
                `,
                css``,
                null,
            ])}
    `,
};
